import styled, { css } from 'styled-components';

interface InputProps {
  value: string;
}

export const Container = styled.div`
  position: relative;

  textarea {
    min-height: 150px;
  }

  input[type="color"] {
    padding-left: 56px;
  }
`;

export const Text = styled.span`
  color: #E5E5E5;
  height: 57px;
  position: absolute; 
  top: 0;
  left: 16px;

  display: flex;
  align-items: center;

  transform-origin: 0% 0%;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;

  transition: .1s ease-in-out;
`;

const inputCSS = css`
  background: #53585D;
  color: #F5F5F5;
  display: block;
  width: 100%;
  height: 57px;
  font-size: 18px;
  
  outline: 0;
  border: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid #53585D;
  
  padding: 16px 16px;
  margin-bottom: 45px;
  
  resize: none;
  border-radius: 4px;
  transition: border-color .3s;
  
  &:focus {
    border-bottom-color: var(--primary);
  }

  &:focus:not([type='color']) + ${Text} {
    transform: scale(.6) translateY(-10px);
  }

`;

export const CustomInput = styled.input<InputProps>`
  ${inputCSS};
  
  ${({ value }) => {
    const hasValue = value.length > 0;
    return hasValue && css`
        &:not([type='color']) + ${Text} {
          transform: scale(.6) translateY(-10px);
        }
      `;
    }
  }
`;


export const CustomTextarea = styled.textarea<InputProps>`
  ${inputCSS};

  ${({ value }) => {
    const hasValue = value.length > 0;
    return hasValue && css`
        &:not([type='color']) + ${Text} {
          transform: scale(.6) translateY(-10px);
        }
      `;
    }
  }
`;
